<template>
  <div :class="`home-modal ${showHomeModal ? 'active' : 'passive'}`" @click.self="hideModal">
    <div class="inner lines-bg">
      <img src="https://images.ctfassets.net/3dar4x4x74wk/01zALPeLCH7gIaMLPPkBEa/f5a4545b05f579be5164ed02ed39b8a5/ME_FY25_Summer_Birthday_Upgrade_Web_Pop_Up_512x512.png" alt="Birthday Party at Main Event">
      <div>
        <h1>Free Party Upgrade</h1>
        <p>Celebrate your birthday on a weekday and we’ll throw in the gift of extra epic fun with a free party upgrade! Click on the link below or chat with your local Main Event center to get the party started. All you have to do is book by 8/31 and mention code LEVEL UP!</p>
        <button class="button magenta pulse" @click="goTo()">Level Up</button>
      </div>
      <button @click="hideModal">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" :fill="'#000'" class="bi bi-x" viewBox="0 0 16 16">
          <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>

export default {  
  name: 'HomeModal',
  mounted() {
    console.log('showHomeModal:', this.showHomeModal)
  },
  computed: {
    showHomeModal() {
      return this.$store.state.homeModal
    },
    isMobile() {
      return this.$mq === 'sm' || this.$mq === 'md'
    }
  },
  methods: {
    hideModal() {      
      this.$store.commit('setHomeModal', false)
      document.body.style.overflow = 'auto'
    },
    goTo() {
      this.hideModal()
      this.$router.push('/specials/birthdays-level-up')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_variables';

.home-modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 50;
  background: rgba(#000, .6);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 16px;

  &.passive {
    display: none;
  }

  .inner {
    position: relative;
    width: 100%;
    max-width: 500px;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    background-position: initial;
    gap: 24px;
    border-radius: 4px;
    padding: 20px 16px;

    @media (min-width: $md) {
      max-width: 950px;
      flex-direction: row;
      justify-content: space-between;
      padding: 40px;
    }

    img {
      width: 100%;
      height: 300px;
      border-radius: 4px;
      object-fit: cover;
      object-position: center;

      @media (min-width: $md) {
        max-width: 400px;
        height: auto;
      }
    }

    > div {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 16px;

      h1 {
        font-family: $pie;
        text-transform: uppercase;
        color: $magenta;
        font-size: 38px;
        line-height: 1;
        text-align: center;

        @media (min-width: $md) {
          font-size: 44px;
        }

        @media (min-width: $lg) {
          font-size: 52px;
        }
      }

      p {
        font-weight: 600;
        line-height: 1.22;
        text-align: center;
      }
    }

    > button {
      position: absolute;
      top: 28px;
      right: 24px;
      width: fit-content;
      padding: unset;
      height: 32px;
      border-radius: 100%;

      @media (min-width: $md) {
        top: 24px;
        background: unset;

      }
    }
  }
}
</style>